import fetchAllProducts from "@api/operations/fetch-all-products";
import Product from "@api/types/product";
import { GetStaticPropsContext, InferGetStaticPropsType } from "next";
import Head from "next/head";

import Container from "@components/Container";
import MainLayout from "@components/MainLayout";
import ProductCardGrid from "@components/ProductCardGrid";
import Spacer from "@components/Spacer";

export async function getStaticProps(context: GetStaticPropsContext) {
  const products: Product[] = await fetchAllProducts();

  return {
    props: {
      products,
    },
    revalidate: 300, // 5 minutes in seconds
  };
}

export type IndexPropsType = InferGetStaticPropsType<typeof getStaticProps>;

export default function CourseCatalog({ products }: IndexPropsType) {
  return (
    <>
      <Head>
        <title>Course Catalog | Bobcat Online Training</title>
      </Head>
      <Spacer size="md" />
      <Container>
        <ProductCardGrid products={products} />
      </Container>
    </>
  );
}

CourseCatalog.Layout = MainLayout;
